import "rxjs/add/operator/catch";
import "rxjs/add/operator/map";

import { Injectable } from "@angular/core";
import { Http } from "@angular/http";
import { HttpClient } from "@angular/common/http";

import { HeaderService } from "../services/header.service";
import { ExamineeModel } from "./examinee.model";

@Injectable()
export class ExamineesService {
  readonly url: string = "/api/Examinees/search";
  public selectedOrg: any;

  constructor(
    private _http: Http,
    private http: HttpClient,
    public headerService: HeaderService
  ) {}

  searchExaminees(request): any {
    this.selectedOrg = this.headerService.getselectedOrgDetails();
    request.orgId = this.selectedOrg.orgId;
    return this._http
      .post(this.url, request)
      .map((res: any) => res.json())
      .map((res: any) =>
        res.results.map((record: any) => {
          return <ExamineeModel>{
            taaPin: record["ACCOMMS_PIN"],
            firstName: record["FIRST_NM"],
            lastName: record["LAST_NM"],
            actId: record["ACT_ID"],
            studentId: record["STATE_SYSTEM_ID"],
            dob: record["BIRTH_DT"],
            certification: record["CERTIFIED_FL"],
            middleInitial: record["MIDDLE_NM"],
            status: record["DISPLAY_CD"],
            submittedBy: record["SUBMITTED_BY_NM"],
            submittedDate: record["SUBMITTED_BY_DT"]
              ? new Date(record["SUBMITTED_BY_DT"])
              : undefined,
            test: record["TEST_NM"],
            taName: record["TEST_DATE_NM"],
            personId: record["PERSON_ID"],
            requestId: record["REQUEST_ID"],
            extPersonId: record["EXT_PERSON_ID"]
          };
        })
      );
  }

  searchExamineeResults(body: any) {
    return this._http.post(this.url, body).map(res => res.json());
  }

  getExportData(body: any) {
    return this._http
      .post("/api/Examinees/export", body)
      .map(res => res.json());
  }

  getPersonTable(personId: any) {
    const filter = { where: { PERSON_ID: personId } };
    return this._http
      .get(`/api/PERSON_TESTs`, { params: { filter: filter } })
      .map(res => res.json());
  }
  getTestTable(testDateId) {
    return this.http.get(`/api/TestDate/getReqTestDates`, {
      params: { type: testDateId },
      responseType: "json",
      observe: "response"
    });
  }
  public updatePersonTest(data) {
    return this._http.put(
      `/api/PersonTest/updatePersonTestOnCertification`,
      data
    );
  }
}



// WEBPACK FOOTER //
// ./client/views/examinees/examinees.service.ts